import { getUser } from '../AppServices';
import { MODELS } from '../Lib/constants';

export const dealersListUri = () => ({
  query: {
    id: 'dealersListForTable',
  },
  aggregate: true,
  model: MODELS.Dealer,
});

export const subDealersListUri = () => ({
  query: {
    id: 'dealersListForTable',
    addOnFilter: {
      email: getUser()?.email,
    },
  },
  aggregate: true,
  model: MODELS.Dealer,
});
export const allDealersListUri = () => ({
  query: {
    id: 'employeeDealersListForTable',
    addOnFilter: {
      email: getUser()?.email,
    },
  },
  aggregate: true,
  model: MODELS.APPRAISE_EMPLOYEE,
});
export const dealersKycListUri = () => ({
  query: {
    id: 'dealerKycListForTable',
  },
  aggregate: true,
  model: MODELS.Dealer,
});

export const dealersListForAccountManageUri = () => ({
  query: {
    id: 'dealersListForAccountManageTable',
  },
  aggregate: true,
  model: MODELS.Dealer,
});

export const EditDealerURI = ({ navigation }) => ({
  query: {
    model: MODELS.Dealer,
    id: 'getDealerDetails',
    relationValue: {
      model: MODELS.Dealer,
      _id: navigation?.state?.params?.item?._id,
      relation: '_id',
    },
    limit: 1,
  },
  model: MODELS.Dealer,
});

export const configurationUri = ({ navigation }) => ({
  query: {
    model: MODELS.Dealer,
    id: 'configure',
    relationValue: {
      model: MODELS.Dealer,
      _id: navigation?.state?.params?.item?._id,
      relation: '_id',
    },
    limit: 1,
  },
  model: MODELS.Dealer,
});

export const settingUri = ({ navigation }) => {
  const user = getUser();
  let toPassId;
  if (user.role.code === 'superadmin' || user.role.code === 'admin') {
    toPassId = navigation?.state?.params?.item?._id;
  } else if (user.role.code === 'dealer' || user.role.code === 'superdealer' || user.role.code === 'manager' ) {
    toPassId = user?.dealer?._id;
  }
  return {
    query: {
      model: MODELS.Dealer,
      id: 'setting',
      relationValue: {
        model: MODELS.Dealer,
        _id: toPassId,
        relation: '_id',
      },
      limit: 1,
    },
    model: MODELS.Dealer,
  };
};

export const EditDealerKycURI = ({ navigation }) => ({
  query: {
    model: MODELS.Dealer,
    id: 'getDealerKycDetails',
    relationValue: {
      model: MODELS.Dealer,
      _id: navigation?.state?.params?.item?._id,
      relation: '_id',
    },
    limit: 1,
  },
  model: MODELS.Dealer,
});

export const EditDealerForManageAccountURI = ({ navigation }) => ({
  query: {
    model: MODELS.Dealer,
    id: 'getManageDealerAccountDetails',
    relationValue: {
      model: MODELS.Dealer,
      _id: navigation?.state?.params?.item?._id,
      relation: '_id',
    },
    limit: 1,
  },
  model: MODELS.Dealer,
});

export const dealerSettingsURI = () => {
  const dealerId = getUser()?.dealer?._id;
  return {
    query: {
      model: MODELS.Dealer,
      id: 'getManageDealerAccountDetails',
      relationValue: {
        model: MODELS.Dealer,
        _id: dealerId,
        relation: '_id',
      },
      limit: 1,
    },
    model: MODELS.Dealer,
  };
};

export const setupDealerAccountUri = ({ navigation }) => ({
  query: {
    model: MODELS.Dealer,
    id: 'setupDealerAccountDetails',
    relationValue: {
      model: MODELS.Dealer,
      _id: navigation?.state?.params?.item?._id,
      relation: '_id',
    },
    limit: 1,
  },
  model: MODELS.Dealer,
});

export const getAppraisalRecordURI = (id) => (
  console.log(id),

  {
  query: {
    model: MODELS.ARCDKModel,
    id: 'allData',
    relationValue: {
      model: MODELS.ARCDKModel,
      _id: id,
      relation: '_id',
    },
  },
  model: MODELS.ARCDKModel,
}

);
